// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

/**
 * Pokemon Universe - Aliens Configuration
 * 
 * IMPORTANT: This file only contains the planet-to-alien mapping.
 * All alien definitions are in src/config/AlienSpeciesConfig.js
 * 
 * Workflow:
 * 1. Add alien to AlienSpeciesConfig.js first
 * 2. Then map it to planets here
 */

export const PokemonAliensPlanets = {
  planets: {
    // Kanto Prime (600)
    600: ['pikachu', 'eevee', 'charizard', 'mewtwo', 'teamrocket'],
    
    // Johto System (601)
    601: ['pikachu', 'eevee', 'teamrocket'],
    
    // Hoenn Archipelago (602)
    602: ['rayquaza'],
    
    // Sinnoh Highlands (603)
    603: ['lucario', 'dialga', 'palkia', 'giratina', 'cynthia'],
    
    // Unova Metropolis (604) - Urban station, no wild Pokémon
    604: ['pikachu', 'teamrocket'],
    
    // Kalos Nebula (605)
    605: ['greninja'],
    
    // Alola Paradise (606)
    606: ['ultrabeast'],
    
    // Galar Expanse (607)
    607: ['charizard', 'leon'],
    
    // Paldea Frontier (608) - Frontier world, no assigned Pokémon yet
    608: ['eevee'],
    
    // Orre Wasteland (609) - Desert wasteland, no wild Pokémon
    609: ['teamrocket', 'ultrabeast'],
    
    // Pokémon League Station (610) - Elite trainers only
    610: ['cynthia', 'leon']
  },
  
  // Random encounter aliens (for space travel events)
  randomEncounters: [
    'pikachu',
    'eevee',
    'teamrocket'
  ],
  
  // Hostile species
  hostileSpecies: [
    'teamrocket',
    'ultrabeast',
    'giratina'
  ],
  
  // Friendly traders
  friendlyTraders: [
    'pikachu',
    'eevee'
  ]
};

export default PokemonAliensPlanets;
